export const SET_ACTIVE_PUZZLE = "SET_ACTIVE_PUZZLE";
export const PUZZLE_SOLVED = "PUZZLE_SOLVED";
export const SKIP_PUZZLES = "SKIP_PUZZLES";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const CLOSE_MENU = "CLOSE_MENU";



// WEBPACK FOOTER //
// ./src/constants/action-types.js